import { connect } from 'react-redux'
import CurrentInvitations from './current-invitations'
import { fetchCurrentInvitations } from '../../../../stores/current-invitations/current-invitations.actions'
import {
  getFetchInvitationsRequest,
  getInvitations,
  getPagination
} from '../../../../stores/current-invitations/current-invitations.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const fetchInvitationsRequest = getFetchInvitationsRequest(state)
  const invitations = getInvitations(state)
  return {
    noInvitations: invitations && !invitations.result.length,
    pending: !invitations || fetchInvitationsRequest.pending,
    pagination: getPagination(state)
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    return dispatch(fetchCurrentInvitations())
  },
  onPageChange: ({ selected }) =>
    dispatch(fetchCurrentInvitations({ page: selected })).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentInvitations)
